module.exports = __webpack_public_path__ + "img/ji@3x.64fb88ca.png";